// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BrlktEU6RIG5jXJJYoRn.pXQFk9Z47gE3zFvZJz96{grid-template-rows:96px 1fr}.EaKELZft70jgHgfwQy3k{grid-template-rows:1fr;display:grid;overflow:hidden}.Uow1W8KFysknU2LWVFoJ{padding:12px 8px 12px 16px}.Uow1W8KFysknU2LWVFoJ.pXQFk9Z47gE3zFvZJz96{border-bottom:none;padding:0 20px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `BrlktEU6RIG5jXJJYoRn`,
	"isNew": `pXQFk9Z47gE3zFvZJz96`,
	"content": `EaKELZft70jgHgfwQy3k`,
	"header": `Uow1W8KFysknU2LWVFoJ`
};
export default ___CSS_LOADER_EXPORT___;
